export default __webpack_public_path__ + "static/media/upload.5017ef1d.svg";